import React, { useEffect, useRef, useState } from 'react';
import { Menu } from 'react-daisyui';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronDown, FaHome } from 'react-icons/fa';
import requests from '../Requests';
import Loader from './Loader';

function MenuAtas() {
  const location = useLocation();
  const [menus, setMenus] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // menu aktif
  const [activeMenu, setActiveMenu] = useState(null);

  // submenu aktif
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  const menuRef = useRef();

  const getDataMenus = async () => {
    try {
      const dataMenus = await fetch(requests.requestMenus, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${requests.token_web}`,
        },
      });

      const valueMenus = await dataMenus.json();

      setMenus(valueMenus.menu.items || []);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDataMenus();
  }, []);

  // klik luar menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setActiveMenu(null);
        setActiveSubmenu(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setActiveMenu(null);
    setActiveSubmenu(null);
  }, [location.pathname]);

  return (
    <div ref={menuRef} className="relative overflow-visible">
      <Menu horizontal className="flex flex-row items-center gap-3 overflow-visible align-middle">

        {isLoading && <Loader />}

        {!isLoading && (
          <>
            <Menu.Item>
              <a
                href="/"
                className="flex items-center gap-1 px-2 text-lg hover:text-yellow-500"
              >
                <FaHome />
              </a>
            </Menu.Item>

            {menus.map((menu, index) => {

              const hasChildren =
                menu.children && menu.children.length > 0;

              return (
                <div key={menu.id || index} className="relative">

                  {/* MENU UTAMA */}
                  {!hasChildren ? (
                    <a
                      href={menu.url}
                      className="flex items-center gap-1 px-2 py-2 text-lg hover:text-yellow-500"
                    >
                      {menu.title}
                    </a>
                  ) : (
                    <>
                      <button
                        onClick={() => {
                          setActiveSubmenu(null);

                          if (activeMenu === index) {
                            setActiveMenu(null);
                          } else {
                            setActiveMenu(index);
                          }
                        }}
                        className="flex items-center gap-1 px-2 py-2 text-lg hover:text-yellow-500"
                      >
                        {menu.title}
                        <FaChevronDown className="text-xs" />
                      </button>

                      {/* DROPDOWN MENU */}
                      {activeMenu === index && (
                        <div
                          className="
    absolute
    top-full
    right-0
    z-50
    w-72
    max-w-[calc(100vw-20px)]
    bg-white
    border
    rounded-lg
    shadow-lg
    overflow-visible
    text-gray-800
  "
                        >

                          {menu.children.map((submenu, subIndex) => {

                            const hasSubChildren =
                              submenu.children &&
                              submenu.children.length > 0;

                            return (
                              <div
                                key={submenu.id || subIndex}
                                className="relative"
                              >

                                {/* SUBMENU */}
                                {!hasSubChildren ? (
                                  submenu.url.includes('http') ? (
                                    <a
                                      href={submenu.url}
                                      target={submenu.target || '_blank'}
                                      rel="noreferrer"
                                      className="
block
px-4 py-2
text-lg
whitespace-normal
break-words
max-w-[90vw]
hover:bg-blue-logo-kemdikbud
hover:text-white
"
                                    >
                                      {submenu.title}
                                    </a>
                                  ) : (
                                    <Link
                                      to={submenu.url}
                                      className="
block
px-4 py-2
text-lg
whitespace-normal
break-words
max-w-[90vw]
hover:bg-blue-logo-kemdikbud
hover:text-white
"
                                    >
                                      {submenu.title}
                                    </Link>
                                  )
                                ) : (
                                  <>
                                    <button
                                      onClick={() => {
                                        const key = `${index}-${subIndex}`;

                                        if (activeSubmenu === key) {
                                          setActiveSubmenu(null);
                                        } else {
                                          setActiveSubmenu(key);
                                        }
                                      }}
                                      className="
flex
items-center
justify-between
w-full
gap-3
px-4
py-2
text-lg
text-left
whitespace-normal
break-words
max-w-[90vw]
hover:bg-blue-logo-kemdikbud
hover:text-white
align-middle
"
                                    >
                                      {submenu.title}
                                      <FaChevronDown className="text-xs rotate-[-90deg]" />
                                    </button>

                                    {/* SUBSUBMENU */}
                                    {activeSubmenu === `${index}-${subIndex}` && (
                                      <div
                                        className="
    absolute
    top-0
    right-full
    mr-1
    z-50
    w-72
    max-w-[calc(100vw-20px)]
    bg-white
    border
    rounded-lg
    shadow-lg
    overflow-visible
  "
                                      >

                                        {submenu.children.map(
                                          (subsubmenu, subsubIndex) => (
                                            <div
                                              key={
                                                subsubmenu.id || subsubIndex
                                              }
                                            >
                                              {subsubmenu.url.includes(
                                                'http'
                                              ) ? (
                                                <a
                                                  href={subsubmenu.url}
                                                  target={
                                                    subsubmenu.target || '_blank'
                                                  }
                                                  rel="noreferrer"
                                                  className="flex items-center justify-between w-full gap-3 px-4 py-2 text-lg text-left break-words whitespace-normal hover:bg-blue-logo-kemdikbud hover:text-white"
                                                >
                                                  {subsubmenu.title}
                                                </a>
                                              ) : (
                                                <Link
                                                  to={subsubmenu.url}
                                                  className="flex items-center justify-between w-full gap-3 px-4 py-2 text-lg text-left break-words whitespace-normal hover:bg-blue-logo-kemdikbud hover:text-white"
                                                >
                                                  {subsubmenu.title}
                                                </Link>
                                              )}
                                            </div>
                                          )
                                        )}
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </>
        )}
      </Menu>
    </div>
  );
}

export default MenuAtas;